import { ProgramAvailablity } from "src/enums";
import { Channel, ChannelProgram, PlayerUrl, ProgramMessage } from "src/models";

export type TvModel = {
    channels: Channel[];
    channelsLoading: boolean;

    conductor: ChannelProgram[];
    conductorLoading: boolean;
    currentDate?: Date;
    currentChannel?: Channel;
    searchText?: string;
    episode?:  ChannelProgram;

    showConductor: boolean;

    player?: PlayerUrl;
    reporting: boolean;
    availability?: ProgramAvailablity;
    message: ProgramMessage;
    killSessionId: string[];
};

export const TvModelInitialState: TvModel = {

    channels: [],
    channelsLoading: true,
    conductor: [],
    conductorLoading: true,
    showConductor: false,
    reporting: false,
    message: {
        hasMessage: false
    },
    killSessionId: []
};